// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.5 2.71741L1 5.92575V21.5001L6.5 19.2328V2.71741Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.5 18.9097L13.5 21.8625V21.6904C12.2673 20.5075 11.5 18.8434 11.5 17C11.5 15.1566 12.2673 13.4925 13.5 12.3096V5.09051L8.5 2.1377V18.9097Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 2.50012V11.2322C20.1025 10.7644 19.0821 10.5 18 10.5C17.1141 10.5 16.2696 10.6772 15.5 10.9982V4.76744L21 2.50012Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5864 21.6572L23.6575 14.5861L22.2432 13.1719L16.5864 18.8287L13.758 16.0003L12.3437 17.4145L16.5864 21.6572Z"}}]};

const MapCheckedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-checked-filled',
    ref,
    icon: element,
  },
));

MapCheckedFilledIcon.displayName = 'MapCheckedFilledIcon';

export default MapCheckedFilledIcon;
